import { SupportedApplication } from "@shopliftr/common-js/shared";
import packageInfo from "apps/partner/package.json";
import { IAppConfig } from "../app/common/interfaces/app-config";

/**
 * Invariant configuration shared by every partner environment.
 *
 * Environment-specific settings (URLs, telemetry and production/staging
 * flags) are declared explicitly in each concrete environment file so that
 * every config states its own effective settings. Login credentials are
 * intentionally NOT declared here — they are shared via `dev-logins.ts` and
 * imported per environment so they are never bundled into builds that should
 * not ship them (e.g. production).
 */
export const environment: Pick<IAppConfig, "appVersion" | "appName" | "authentication"> = {
    appVersion: packageInfo.version,
    appName: SupportedApplication.PartnerPortal,
    authentication: {
        logoUrl: "/assets/images/logo-black-shopliftr.svg",
        heading: "Partner Portal"
    }
};
